// Plain values the spreadsheet mapping's controls share, kept out of the
// component files so fast refresh keeps working.

export const inputCls =
  'w-full rounded border border-border bg-background px-1.5 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-tres-action';

/** A term as a pick list shows it: its label, then the term itself. */
export const termLabel = (uri: string, label: string | null | undefined) => (label ? `${label} (${uri})` : uri);
